<template>
  <v-row>
    <v-col class="mt-2" cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card>
        <v-card-title class="theme">
          <v-icon class="white--text">list</v-icon>
          <span class="headline ml-2 white--text">Edit Timeoff Policy</span>
          <v-spacer />

          <!-- <v-btn depressed color="primary lighten-1" class="text-capitalize">assign</v-btn> -->
          <v-btn
            depressed
            @click="dialog = true"
            class="rounded-sm error lighten-1"
            >delete
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container>
              <v-row>
                <v-col class="pt-0" cols="12">
                  <div class="headline">General Settings</div>
                  <small>General settings for all the timeoff policies</small>
                </v-col>
                <v-col cols="12" lg="5">
                  <v-text-field
                    v-model="timeoff.name"
                    label="Name *"
                    validate-on-blur
                    :rules="[validationRules.required]"
                    hint="Name of this policy"
                    :disabled="tempDisable"
                    :persistent-hint="true"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="grey--text pt-1" v-on="on"
                            >help</v-icon
                          >
                        </template>
                        For e.g. Norway - Vacation policy.
                        <br />
                        This will be visible to the customers trying to use this
                        policy
                      </v-tooltip>
                    </template>
                  </v-text-field>

                  <v-checkbox
                    v-model="timeoff.count_holidays"
                    label="Count as calenday days"
                    hint="Should the weekends and holidays be treated as calendar days."
                    :disabled="tempDisable"
                    persistent-hint
                    class="my-4"
                  />

                  <v-autocomplete
                    v-model="timeoff.type"
                    label="Type *"
                    :items="setup.types"
                    validate-on-blur
                    :rules="[validationRules.required]"
                    hint="type for this policy"
                    :disabled="tempDisable"
                    :persistent-hint="true"
                    class="my-4"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="grey--text pt-1" v-on="on"
                            >help</v-icon
                          >
                        </template>
                        Vacation, Sick Leave or others
                      </v-tooltip>
                    </template>
                  </v-autocomplete>

                  <v-autocomplete
                    :items="countries"
                    v-model="timeoff.country"
                    item-text="name"
                    item-value="name"
                    :disabled="tempDisable"
                    label="Country *"
                    validate-on-blur
                    :rules="[validationRules.required]"
                    hint="Select the location where this policy is applicable"
                    :persistent-hint="true"
                    clearable
                    class="my-4"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="grey--text pt-1" v-on="on"
                            >help</v-icon
                          >
                        </template>
                        Please select the Country where you want to apply this
                        policy.
                      </v-tooltip>
                    </template>
                  </v-autocomplete>

                  <v-textarea
                    rows="3"
                    v-model="timeoff.description"
                    :disabled="tempDisable"
                    label="Description *"
                    hint="Some details for this policy"
                    :persistent-hint="true"
                    clearable
                    class="my-4"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="grey--text pt-1" v-on="on"
                            >help</v-icon
                          >
                        </template>
                        Description about this vacation to help your employees.
                      </v-tooltip>
                    </template>
                  </v-textarea>

                  <v-text-field
                    label="Start date for year*"
                    v-mask="masks.timeoffStartOfYear"
                    hint="in dd-mm format"
                    :persistent-hint="true"
                    :disabled="tempDisable"
                    validate-on-blur
                    clearable
                    :rules="[
                      timeoff && validationRules.required,
                      timeoff && validationRules.timeoffStartOfYear,
                    ]"
                    v-model="timeoff.start_date"
                    class="my-4"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="grey--text pt-1" v-on="on"
                            >help</v-icon
                          >
                        </template>
                        This will be used to mark the start of the year and<br />
                        calculate the carryover leaves for employees
                      </v-tooltip>
                    </template>
                  </v-text-field>

                  <v-text-field
                    :disabled="tempDisable"
                    v-model="timeoff.days"
                    v-mask="['###']"
                    clearable
                    type="number"
                    min="1"
                    max="365"
                    hint="number of days under this timeoff type"
                    :persistent-hint="true"
                    class="my-4"
                    :rules="[
                      validationRules.required,
                      validationRules.timeoffDefaultVacationDays,
                    ]"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="grey--text pt-1" v-on="on"
                            >help</v-icon
                          >
                        </template>
                        Maximum number of days employees can ask for this
                        timeoff.
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="7"></v-col>

                <v-col cols="12">
                  <v-divider />
                  <v-row>
                    <v-col cols="6">
                      <div class="headline mt-3">Timeoff accrual policy</div>
                      <small
                        >At what frequency do employees earn timeoff under this
                        policy</small
                      >
                    </v-col>
                    <v-col cols="6">
                      <v-switch
                        style="float: right"
                        v-model="timeoff.accrual.enabled"
                        color="primary"
                        :disabled="true"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" lg="5">
                  <v-autocomplete
                    :items="setup.accrual.frequency"
                    v-model="timeoff.accrual.data.frequency"
                    label="Frequency *"
                    validate-on-blur
                    :rules="[
                      requiredWithField(
                        timeoff.accrual.enabled,
                        timeoff.accrual.data.frequency
                      ),
                    ]"
                    hint="At which the employees earn timeoff"
                    :persistent-hint="true"
                    clearable
                    :disabled="!timeoff.accrual.enabled"
                    class="my-4"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="grey--text pt-1" v-on="on"
                            >help</v-icon
                          >
                        </template>
                        Specify how frequently employees earn the timeoff.
                      </v-tooltip>
                    </template>
                  </v-autocomplete>

                  <v-autocomplete
                    :items="setup.accrual.timing"
                    v-model="timeoff.accrual.data.timing"
                    label="Accruals are earned at *"
                    validate-on-blur
                    :rules="[
                      requiredWithField(
                        timeoff.accrual.enabled,
                        timeoff.accrual.data.timing
                      ),
                    ]"
                    hint="Beginning or End of the period"
                    :persistent-hint="true"
                    clearable
                    :disabled="!timeoff.accrual.enabled"
                    class="my-4"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="grey--text pt-1" v-on="on"
                            >help</v-icon
                          >
                        </template>
                        Specify if the accruals are earned at the start of the
                        <br />period or end of the period.
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-divider />
                  <v-row>
                    <v-col cols="6">
                      <div class="headline mt-3">Restrictions on usage</div>
                      <small
                        >Put a cap on the usage of this timeoff policy</small
                      >
                    </v-col>
                    <v-col cols="6">
                      <v-switch
                        style="float: right"
                        v-model="timeoff.restrictions.enabled"
                        color="primary"
                        :disabled="tempDisable"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" lg="5">
                  <v-text-field
                    clearable
                    label="Cap request"
                    hint="Maximum number of timeoff requests per cap duration "
                    v-mask="['###']"
                    type="number"
                    min="1"
                    max="365"
                    :persistent-hint="true"
                    :disabled="!timeoff.restrictions.enabled"
                    validate-on-blur
                    :rules="[
                      requiredWithField(
                        timeoff.restrictions.enabled,
                        timeoff.restrictions.data.cap_request
                      ),
                    ]"
                    v-model="timeoff.restrictions.data.cap_request"
                    class="my-4"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="grey--text pt-1" v-on="on"
                            >help</v-icon
                          >
                        </template>
                        Specify the number of times this timeoff can be
                        requested by
                        <br />the employee within a year.
                      </v-tooltip>
                    </template>
                  </v-text-field>

                  <v-text-field
                    clearable
                    label="Cap days"
                    hint="Maximum number of days per cap request"
                    v-mask="['###']"
                    type="number"
                    min="1"
                    max="365"
                    :persistent-hint="true"
                    :disabled="!timeoff.restrictions.enabled"
                    validate-on-blur
                    :rules="[
                      requiredWithField(
                        timeoff.restrictions.enabled,
                        timeoff.restrictions.data.cap_days
                      ),
                    ]"
                    v-model="timeoff.restrictions.data.cap_days"
                    class="my-4"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip right>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="grey--text pt-1" v-on="on"
                            >help</v-icon
                          >
                        </template>
                        Specify the maximum number of days that can be taken per
                        cap
                        <br />request.
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" lg="7"></v-col>

                <v-col cols="12">
                  <v-divider />
                  <v-row>
                    <v-col cols="6">
                      <div class="headline mt-3">Timeoff carryover</div>
                      <small
                        >Configure the available days that can be carried over
                        to next period</small
                      >
                    </v-col>
                    <v-col cols="6">
                      <v-switch
                        style="float: right"
                        v-model="timeoff.carryover.enabled"
                        color="primary"
                        :disabled="tempDisable"
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <v-row>
                  <v-col class="pl-6" cols="12" lg="5">
                    <v-text-field
                      v-model="timeoff.carryover.data.balance_limit_days"
                      label="Number of carryover days *"
                      v-mask="['###']"
                      type="number"
                      min="1"
                      max="365"
                      hint="Employees have a limited amount of time-off days at any given time."
                      clearable
                      validate-on-blur
                      class="my-4"
                      :rules="[
                        requiredWithField(
                          timeoff.carryover.enabled,
                          timeoff.carryover.data.balance_limit_days
                        ),
                      ]"
                      :persistent-hint="true"
                      :disabled="!timeoff.carryover.enabled"
                    >
                      <template v-slot:append-outer>
                        <v-tooltip right>
                          <template v-slot:activator="{ on }">
                            <v-icon small class="grey--text pt-1" v-on="on"
                              >help</v-icon
                            >
                          </template>
                          Number of unused timeoff days that can be carried over
                          to next year.
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="7"></v-col>
                </v-row>
              </v-row>
              <v-btn
                depressed
                class="save white--text ml-0 rounded-sm mt-6"
                :disabled="tempDisable"
                @click="save"
                >save
              </v-btn>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline pt-4">
          <v-spacer />
          <span>Are you sure?</span>
          <v-spacer />
        </v-card-title>
        <v-divider />
        <v-card-text class="my-3 text-xs-center"
          >You will not be able to undo this operation.
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn color="success" text @click="dialog = !dialog">cancel</v-btn>
          <v-spacer />
          <v-btn color="error" text @click="deletePolicy">delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";

export default {
  name: Component.Protected.Company.LeaveTypes.Edit,
  directives: { mask },
  data: () => ({
    dialog: false,
    valid: false,
    tokenHeader: null,
    breadcrumbs: Breadcrumbs.Leaves.Edit,
    tempDisable: true,
    timeoffDelegate: null,
    setup: {
      workdays: Constants.LeaveTypes.Messages.Workdays,
      accrual: {
        frequency: Constants.LeaveTypes.Messages.AccrualEarnFrequency,
        timing: Constants.LeaveTypes.Messages.AccrualEarnAt,
      },
      restrictions: {
        cap_duration: Constants.LeaveTypes.Messages.RestrictionPeriods,
      },
      carryover: { dates: Constants.LeaveTypes.Messages.CarryoverStartDate },
      approval: { types: Constants.LeaveTypes.Messages.ApprovalType },
      types: ["Vacation", "Sick Leave", "Others"],
    },
    timeoff: {
      name: "",
      country: "",
      description: "",
      days: 0,
      hours: 75,
      start_date: "",
      workdays: Constants.LeaveTypes.Messages.SelectedWorkdays,
      type: "Country",
      specify: "Specify",
      accrual: {
        enabled: false,
        data: { frequency: "Annual", timing: "Start" },
      },
      restrictions: {
        enabled: false,
        data: { cap_duration: "", cap_request: 0, cap_days: 0 },
      },
      prorate: {
        enabled: false,
        data: { allowed: "No", waiting_period: "No", waiting_duration: 0 },
      },
      carryover: {
        enabled: false,
        data: {
          annual_reset: false,
          annual_reset_date: Constants.LeaveTypes.Messages.Policy,
          unlimited_carryover: false,
          unlimited_carryover_date: Constants.LeaveTypes.Messages.Policy,
          balance_limit_required: false,
          balance_limit_days: 0,
          cap_required: false,
          cap_days: 0,
          cap_date: Constants.LeaveTypes.Messages.Policy,
          cap_with_deadline_required: false,
          cap_with_deadline_days_count: 0,
          cap_with_deadline_days_allowed: 0,
          cap_with_deadline_date: Constants.LeaveTypes.Messages.Policy,
        },
      },
      approval: "Single",
      count_holidays: false,
    },
  }),
  computed: {
    ...mapGetters(["userInfo", "countries"]),
  },
  methods: {
    requiredWithField(dependent, current) {
      if (!dependent) return true;
      if (dependent && current) return true;
      if (dependent && !current) return "Field is required";
      return "Field is required";
    },
    requiredWithTwoFields(x, y, current) {
      if (!x || !y) return true;
      if (x && y && current) return true;
      if (x && y && !current) return "Field is required";
      return "Field is required";
    },
    deletePolicy() {
      if (!this.$route.params.id) return false;
      this.$store
        .dispatch(Actions.LeaveTypes.Delete, this.$route.params.id)
        .then(() => {
          this.$router.push({
            name: Component.Protected.Company.LeaveTypes.List,
          });
        })
        .catch((e) => {
          console.error(Constants.LeaveTypes.Messages.Error.Delete, e);
          this.snackbarMessage = Constants.LeaveTypes.Messages.Error.Delete;
          this.snackbar = true;
        });
    },
    save() {
      if (this.$refs.form.validate()) {
        this.tempDisable = true;
        let payload = {
          ...this.timeoff,
          days: parseInt(this.timeoff.days),
          hours: parseFloat(this.timeoff.hours) / 10,
        };
        // console.log("before", payload);
        payload.prorate.data.waiting_duration = parseInt(
          payload.prorate.data.waiting_duration
        );
        payload.restrictions.data.cap_request = parseInt(
          payload.restrictions.data.cap_request
        );
        payload.restrictions.data.cap_days = parseInt(
          payload.restrictions.data.cap_days
        );
        payload.carryover.data.balance_limit_days = parseInt(
          payload.carryover.data.balance_limit_days
        );
        payload.carryover.data.cap_days = parseInt(
          payload.carryover.data.cap_days
        );
        payload.carryover.data.cap_with_deadline_days_count = parseInt(
          payload.carryover.data.cap_with_deadline_days_count
        );
        payload.carryover.data.cap_with_deadline_days_allowed = parseInt(
          payload.carryover.data.cap_with_deadline_days_allowed
        );
        // console.log(payload);

        this.$store
          .dispatch(Actions.LeaveTypes.Edit, {
            id: this.$route.params.id,
            data: payload,
          })
          .then((r) => {
            if (r.status === 200) {
              this.$router.push({
                name: Component.Protected.Company.LeaveTypes.List,
              });
            }
          })
          .catch((e) => {
            console.error(Constants.LeaveTypes.Messages.Error.Edit, e);
            this.snackbarMessage = Constants.LeaveTypes.Messages.Error.Edit;
            this.snackbar = true;
          });
      }
    },
    getTimeoffPolicy() {
      this.tempDisable = true;
      this.$store
        .dispatch(Actions.LeaveTypes.Get, this.$route.params.id)
        .then((r) => {
          if (r.status === 200) {
            const co = {
              enabled: false,
              data: {
                annual_reset: false,
                annual_reset_date: Constants.LeaveTypes.Messages.Policy,
                unlimited_carryover: false,
                unlimited_carryover_date: Constants.LeaveTypes.Messages.Policy,
                balance_limit_required: false,
                balance_limit_days: 0,
                cap_required: false,
                cap_days: 0,
                cap_date: Constants.LeaveTypes.Messages.Policy,
                cap_with_deadline_required: false,
                cap_with_deadline_days_count: 0,
                cap_with_deadline_days_allowed: 0,
                cap_with_deadline_date: Constants.LeaveTypes.Messages.Policy,
              },
            };
            const pr = {
              enabled: false,
              data: {
                allowed: "No",
                waiting_period: "No",
                waiting_duration: 0,
              },
            };
            const res = {
              enabled: false,
              data: { cap_duration: "", cap_request: 0, cap_days: 0 },
            };
            //const acc = { enabled: false, data: { frequency: "", timing: "" } };
            const acc = {
              enabled: false,
              data: { frequency: "Annual", timing: "Start" },
            };
            this.timeoff = {
              ...r.data,
              carryover: r.data.carryover.enabled
                ? {
                    ...r.data.carryover,
                    enabled: r.data.carryover.enabled,
                    data: {
                      ...r.data.carryover.data,
                      balance_limit_days: parseInt(
                        r.data.carryover.data.balance_limit_days
                      ),
                      cap_days: parseInt(r.data.carryover.data.cap_days),
                      cap_with_deadline_days_count: parseInt(
                        r.data.carryover.data.cap_with_deadline_days_count
                      ),
                      cap_with_deadline_days_allowed: parseInt(
                        r.data.carryover.data.cap_with_deadline_days_allowed
                      ),
                    },
                  }
                : co,
              prorate: r.data.prorate.enabled
                ? {
                    ...r.data.prorate,
                    enabled: r.data.prorate.enabled,
                    data: {
                      ...r.data.prorate.data,
                      waiting_duration: parseInt(
                        r.data.prorate.data.waiting_duration
                      ),
                    },
                  }
                : pr,
              restrictions: r.data.restrictions.enabled
                ? r.data.restrictions
                : res,
              // accrual: r.data.accrual.enabled ? r.data.accrual : acc,
              accrual: acc,
              hours: r.data.hours * 10,
              count_holidays:
                r.data.count_holidays !== null ? r.data.count_holidays : false,
            };
          }
        })
        .catch((e) => {
          console.error(Constants.LeaveTypes.Messages.Error.Get, e);
          this.snackbarMessage = Constants.LeaveTypes.Messages.Error.Get;
          this.snackbar = true;
        })
        .finally(() => (this.tempDisable = false));
    },

    initialize() {
      if (this.userInfo.role !== Constants.Roles.HR) {
        this.$router.go(-1);
        return false;
      }
      this.getTimeoffPolicy();
    },
  },
  created() {
    if (!this.$route.params.id) {
      this.$router.go(-1);
      return false;
    }
    if (this.userInfo && this.userInfo.role) {
      this.initialize();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.initialize());
    }
  },
};
</script>